<!--矩形边框-->
<template>
  <div class="Ds-circle-border">

  </div>
</template>

<script>
	export default {
		name: 'DsCircleBorder',
	}
</script>

<style lang="scss" scoped>
</style>
